<!--用电日历-->
<template>
  <div class="calender_box">
    <div class="calender_tit">
      <div class="text">用电日历</div>
    </div>
    <div class="calender">
      <div class="unit"> <el-date-picker v-model="value" type="month" placeholder="选择月" size="small">
        </el-date-picker> <span style="margin-left:10px;">单位：KW·h</span></div>
      <div class="ul">
        <div class="li" v-for="(item,index) in ul" :key="index" :style="{    borderColor: item.color}">
          <div class="l">{{!index?0:''}}</div>
          <div class="r">{{item.num}}</div>
        </div>
      </div>
      <el-calendar v-model="value" v-if="loding">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{date, data}">
          <div class="box" :class="classObject(listData[data.day])">
            <p style="margin-top: 28px;" class="p">
              {{ data.day.split('-').slice(2)[0] }}日
            </p>
            <p class="p" style="font-size: 20px;font-weight: bold;">{{ listData[data.day]?listData[data.day]:'' }}</p>
          </div>
        </template>

      </el-calendar>
    </div>
  </div>

</template>

<script type="text/javascript">
  import request from "@/api/http.js";
  export default {

    data () {
      return {
        loding: true,
        ul: [{
          num: '100,000',
          color: '#19E92E',
          bgc: '#baf8c0',
        },{
          num: '150,000',
          color: '#FFDB1D',
          bgc: '#fff4bb',
        },{
          num: '200,000',
          color: '#FF7C1D',
          bgc: '#ffd8bb',
        },{
          num: '250,000',
          color: '#FF1D1D',
          bgc: '#ffbbbb',
        },],
        value: new Date(),//显示当前年月日
        listData: {//数据
          '2023-05-01': '45,000.56',
          '2023-05-02': '55,000.56',
          '2023-05-03': '110,000.56',
          '2023-05-04': '150,000.56',
        }
      }
    },

    // 监听v-model中值的变化
    watch: {
      value: {
        handler (newVal,oldVal) {
          this.getList()
        },
      }
    },
    mounted () {
      // el-button el-button--plain el-button--mini
      document.querySelectorAll('.el-button--plain span')[1].innerHTML='本月';
      var d=document.querySelectorAll('thead th');
      for(let i=0;i<d.length;i++) {
        d[i].innerHTML='周'+d[i].innerHTML;
      }
      this.getList()
    },
    methods: {
      valueFn () {
        this.loding=false;
        setTimeout(() => {
          this.loding=true;
          setTimeout(() => {
            document.querySelectorAll('.el-button--plain span')[1].innerHTML='本月';
            var d=document.querySelectorAll('thead th');
            for(let i=0;i<d.length;i++) {
              d[i].innerHTML='周'+d[i].innerHTML;
            }
          },100);
        },100);
      },
      // 获取数据
      getList (v) {
        var params={
          "dataTime": this.value.getTime(),
          "unitId": this.$store.unitStore.getters.getNowUnit.id,
        }
        request({url: "/calendar/find",method: "get",params}).then(res => {
          if(res.code==200) {
            // 用电阈值
            var b=res.data.setting;
            this.ul[0].num=this.addDou(b.green.toString())
            this.ul[1].num=this.addDou(b.yellow.toString())
            this.ul[2].num=this.addDou(b.orange.toString())
            this.ul[3].num=this.addDou(b.red.toString())

            // 日历数据
            var d=res.data.historyMon;
            var mon=this.value.getMonth()+1

            var a=this.value.getFullYear()+'-'+(mon>9? mon:'0'+mon);

            // console.log(a,'aaa');//年月
            var data={}
            for(const key in d) {
              var day=key>9? key:'0'+key;
              var index=a+'-'+day;
              data[index]=d[key];
            }
            this.listData=data;
            console.log(this.listData);
            this.valueFn();
          } else {
            this.$message({
              message: res.message,
              type: 'info'
            });
          }
        })
      },
      addDou (num) {
        var numArr=num.split('.')
        num=numArr[0]
        var result=''
        while(num.length>3) {
          result=','+num.slice(-3)+result
          num=num.slice(0,num.length-3)
        }
        if(num) {
          result=num+result
        }
        if(numArr[1]) {
          result=result+'.'+numArr[1]
        }

        return result
      },

      classObject (v) {
        if(v) {
          if(v) {
            var d=0
            if(v.toString().indexOf(',')!=-1) {
              d=parseInt(v.replace(',',""));//当日度数
            } else {
              d=parseInt(v);//当日度数
            }

            var num=5;//索引
            for(let i=0;i<this.ul.length;i++) {
              const element=parseInt(this.ul[i].num.replace(',',""));
              if(d<element) {
                num=i+1
                break
              }
            }
          }

          return 'bgc'+num
        }
      }
    }
  }
</script>

<style scoped>
  .bgc1 {
    border-left: 6px solid #19E92E;
    background-color: #baf8c0;
  }

  .bgc2 {
    border-left: 6px solid #FFDB1D;
    background-color: #fff4bb;
  }

  .bgc3 {
    border-left: 6px solid #FF7C1D;
    background-color: #ffd8bb;
  }

  .bgc4 {
    border-left: 6px solid #FF1D1D;
    background-color: #ffbbbb;
  }

  .ul {
    display: flex;
    position: absolute;
    left: 50%;
    top: 12px;
    transform: translateX(-50%);
  }

  .ul .li {
    color: #666;
    width: 120px;
    border-bottom: 8px solid #000;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    margin-right: 3px;

  }

  .calender_box {
    padding: 10px;
  }

  .calender_tit {
    padding: 21px;
    padding-bottom: 0;
    background: #fff;
  }

  .calender_tit .text {
    border-bottom: 2px solid #e6e6e6;
    padding-bottom: 10px;
    font-size: 16px;
    ;
  }

  .calender {
    position: relative;
    width: 100%;
    box-sizing: border-box;

  }



  .box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* color: #000; */
  }

  .box .p {
    margin-top: 15px;
    margin-left: 20px;
    font-size: 16px;
  }

  .unit {
    position: absolute;
    top: 10px;
    left: 20px;
    display: flex;
    align-items: center;
  }
</style>
<style>
  .el-calendar-table td {
    border-bottom: 5px solid #EBEEF5;
  }

  .el-backtop,
  .el-calendar-table td.is-today {
    color: #000;
  }

  .el-calendar-day {
    position: relative;
  }

  .el-calendar__body thead {
    background-color: #368ED9;

  }

  .el-calendar-table thead th {
    color: #fff;
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
  }

  .el-calendar-table .el-calendar-day {
    height: 104px;
  }

  .el-calendar__header {
    border-bottom: none;
  }
</style>